import React from 'react'

export const Backdrop = (props) => {
    return (
        <div 
        className="w-full h-screen fixed top-0 left-0 bg-modal"
        style={{display: props.isOpen ? 'block' : 'none'}}
        onClick={props.backdropHandler}
        >
        </div>
    )
}
